/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  IPaymentListReq,
  IRepayOrderReq,
  IWechatPayReq,
  IValidatePayReq,
  ICheckContactParams,
  ICheckContactResp,
  IPaymentTransactionVo,
  SaveUserPickup,
  INewUserPermissionInfoVo,
  IOrderSuccessInfoVo,
} from './checkout.interface';
import { getFormatCheckoutInfo } from './checkoutRootToCommon';
import { getFormatSubmitInfo } from './convert/SubmitDto2Vo';
import { getFormatPaymentList } from './convert/PaymentDto2Vo';
import { commonBizInfo, USER_TYPE_ENUM } from './constants/constants';
import { jdiColorFetch } from '../colorFetchV2';
import { getFormatMemberOrderSuccessInfo } from "./convert/MemberOrderDto2Vo";

// Search checkout order
export const getCurrentOrder = async (requestData: any) => {
  // 原se_currentOrder
  const res = await jdiColorFetch(
    `trade_checkout_get`,
    {
      method: 'post',
      bodyQuery: { ...requestData },
    },
    { needUniformBizInfo: true },
  );

  const { floors, structure } = res?.data || {};
  return {
    data: getFormatCheckoutInfo(floors, structure),
    localInfo: res?.data?.localInfo || {},
    code: res?.resultCode || '',
    msg: res?.msg || '',
    traceId: res?.traceId || '',
    title: res?.helpMessage || '',
  };
};

export const saveAddress = async (requestData: any) => {
  const res = await jdiColorFetch(
    `trade_checkout_changeAddress`,
    {
      method: 'post',
      bodyQuery: { ...requestData },
    },
    { needUniformBizInfo: true },
  );

  const { floors, structure } = res?.data || {};
  return {
    data: getFormatCheckoutInfo(floors, structure),
    localInfo: res?.data?.localInfo || {},
    code: res?.resultCode || '',
    msg: res?.msg || '',
    traceId: res?.traceId || '',
    title: res?.helpMessage || '',
  };
};

// Submit order

export const submitOrder = async (requestData: any) => {
  const res = await jdiColorFetch(
    `trade_checkout_submit`,
    {
      method: 'post',
      bodyQuery: { ...requestData },
    },
    { needUniformBizInfo: true },
  );
  return {
    code: res?.resultCode || '',
    msg: res?.msg || '',
    data: getFormatSubmitInfo(res?.data?.floors || []),
    traceId: res?.traceId || '',
  };
};

// Search pay result
export const getPayResult = async (requestData: any) => {
  // 原se_payment_getPayResult
  const res = await jdiColorFetch(
    `trade_payment_getPayResult`,
    {
      method: 'post',
      bodyQuery: requestData,
    },
    { needUniformBizInfo: true },
  );
  return {
    data: res?.data,
    traceId: res?.traceId || '',
  };
};

// Search wechat pay result
export const getWechatPayResult = async (requestData: IWechatPayReq) => {
  const res = await jdiColorFetch(
    `trade_payment_getOuterStatus`,
    {
      method: 'post',
      bodyQuery: requestData,
    },
    { needUniformBizInfo: true },
  );

  return res?.data;
};

// Redirect pay result
export const redirectPayResult = async (requestData: any) => {
  // 原se_payment_redirect_result
  const res = await jdiColorFetch(
    `trade_payment_getRedirectPayResult`,
    {
      method: 'post',
      bodyQuery: requestData,
    },
    { needUniformBizInfo: true },
  );
  return {
    data: res?.data as IPaymentTransactionVo,
    traceId: res?.traceId || '',
    code: res.code,
  };
};

// 订单列表PayNow弹层数据查询接口 订单金额&订单支付方式列表
// 导出一个异步函数，用于获取立即支付信息
export const getPayNowInfo = async (requestData: IPaymentListReq) => {
  // 原se_payment_paymethods
  // 使用jdiColorFetch函数，发送post请求，获取支付信息
  const res = await jdiColorFetch(
    `trade_payment_getPayNowInfo`,
    {
      method: 'post',
      bodyQuery: requestData,
    },
    { needUniformBizInfo: true },
  );

  // 返回支付列表、订单信息、记住的信息、跟踪ID和本地信息
  return {
    paymentList: getFormatPaymentList(res?.data?.payMethodList) || [],
    orderInfo: res?.data?.orderPriceInfo,
    rememberInfos: res?.data?.rememberInfos,
    traceId: res?.traceId || '',
    localInfo: res?.data?.localInfo || {},
    code: res?.code,
  };
};

// repay order

export const repayOrder = async (requestData: IRepayOrderReq) => {
  // 原getPayUrl
  const res = await jdiColorFetch(
    `trade_order_getPayUrl`,
    {
      method: 'post',
      bodyQuery: requestData,
    },
    { needUniformBizInfo: true },
  );
  let resData = '';
  try {
    resData = res?.data?.payInfo ? JSON.parse(res?.data?.payInfo) : {};
  } catch (error) {
    console.log('Repay order error api:', error);
  }

  return {
    data: resData,
    msg: res?.msg || '',
    code: res?.code,
    traceId: res?.traceId || '',
  };
};

// 二次支付
export const repayOrderJD = async (requestData: IRepayOrderReq) => {
  // 原 trade_order_getPayUrl
  const res = await jdiColorFetch(
    `trade_payment_pay`,
    {
      method: 'post',
      bodyQuery: requestData,
    },
    { needUniformBizInfo: true },
  );
  let resData = '';
  try {
    resData = res?.data?.payInfo ? JSON.parse(res?.data?.payInfo) : {};
  } catch (error) {
    console.log('Repay order error jd api: ', error);
  }

  return {
    data: resData,
    msg: res?.msg || '',
    code: res?.code,
    traceId: res?.traceId || '',
  };
};

// 查询订单信息接口
export const getCheckoutInfo = async (requestData: any) => {
  // 原se_payment_billing_address
  const res = await jdiColorFetch(
    `trade_payment_getCheckoutInfo`,
    {
      method: 'post',
      bodyQuery: requestData,
    },
    { needUniformBizInfo: true },
  );

  return res?.data;
};

// Save pay billing address
export const updatePaymentBillingAddress = async (requestData: any) => {
  // 原se_payment_billing_address_update
  const res = await jdiColorFetch(
    `trade_payment_modifyBillingAddress`,
    {
      method: 'post',
      bodyQuery: requestData,
    },
    { isCommonArea: false, needUniformBizInfo: true },
  );
  return {
    msg: res.message || '',
    data: res.data,
    success: res.success,
    traceId: res?.traceId || '',
  };
};

/**
 * 支付信息校验：apple pay/信用卡号
 *
 * */
export const validatePaymentInfo = async (requestData: IValidatePayReq): Promise<any> => {
  const res = await jdiColorFetch(
    `trade_payment_validate`,
    {
      method: 'post',
      bodyQuery: requestData,
    },
    { needUniformBizInfo: true },
  );

  return res?.data || {};
};

/**
 * 检查邮箱绑定状态
 * @param params - 请求参数
 * @returns Promise<ICheckContactResp>
 */
export const checkContact = async (params: ICheckContactParams): Promise<ICheckContactResp> => {
  const res = await jdiColorFetch(
    `user_account_checkContact`,
    {
      method: 'post',
      bodyQuery: { ...params },
    },
    { needUniformBizInfo: true },
  );
  return res;
};

/**
 *
 * 修改结算页数据（保存配送时效）
 * @param requestData
 * @returns
 */
export const modifyCheckoutOrder = async (requestData: any) => {
  // 使用jdiColorFetch函数发送post请求，请求地址为trade_checkout_changeAddress，请求体为requestData和uniformBizInfo
  const res = await jdiColorFetch(
    `trade_checkout_modify`,
    {
      method: 'post',
      bodyQuery: { ...requestData, ...commonBizInfo },
    },
    { needUniformBizInfo: true },
  );

  // 从res.data中获取floors和structure
  const { floors, structure } = res?.data || {};
  // 返回一个对象，包含data、localInfo、code和msg
  return {
    data: getFormatCheckoutInfo(floors, structure),
    localInfo: res?.data?.localInfo || {},
    code: res?.resultCode || '',
    msg: res?.msg || '',
    traceId: res?.traceId || '',
  };
};

/**
 * 保存联系人
 */
export const saveUserPickup = async (controllerParam: SaveUserPickup) => {
  const res = await jdiColorFetch(`user_pickup_saveContact`, {
    method: 'post',
    bodyQuery: {
      ...controllerParam,
    },
  });
  return res;
};

/**
 * 获取新人权益信息
 * @param requestData
 * @returns
 */
export const getBenefitInfo = async (requestData: any): Promise<INewUserPermissionInfoVo> => {
  const res = await jdiColorFetch(`marketing_interact_showBenefit`, {
    method: 'post',
    bodyQuery: { ...requestData },
  });
  return res.data;
}

/**
 * 会员订单成功展示
 * @param requestData
 * @returns
 */
export const getMemberOrderInfo = async (requestData: {orderId : string}): Promise<IOrderSuccessInfoVo> => {
  const res = await jdiColorFetch(`trade_payment_getBenefit`, {
    method: 'post',
    bodyQuery: { ...requestData },
  });
  return {
    data: getFormatMemberOrderSuccessInfo(res?.data?.orderPaySuccessFloors || []),
    businessType: res?.data?.businessType as USER_TYPE_ENUM,
  };
};;
